import * as yup from 'yup';
export const createSystemTemplateFormValidation = yup.object().shape({
  //tagId: yup.number().required(' Tag ID is required'),
  //tagName: yup.string().required(' Tag name is required'),
  //brandId: yup.string().required(' Brand Id is required'),
});
